// extracted by mini-css-extract-plugin
module.exports = {"text":"headlineSkins-xxlargeOnConfined-text-8d118f36"};